var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsDeactivateCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4644.000000, -1039.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Deactivate-card",
    transform: "translate(4644.000000, 1039.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,7 C30.657,7 32,8.343 32,10 L32,10 L32,26 C32,27.65 30.65,29 29,29 L29,29 L20.099,29 L22.664,25.589 L18.462,20 L22.664,14.411 L18.595,9 L20.099,7 Z M19.894,4 L16.134,9 L20.202,14.411 L16.047,19.937 L15.987,19.982 L16,20 L15.987,20.018 L16.047,20.062 L20.512,26 L3,26 C1.35,26 8.52651283e-14,24.65 8.52651283e-14,23 L8.52651283e-14,23 L8.52651283e-14,7 C8.52651283e-14,5.35 1.35,4 3,4 L3,4 L19.894,4 Z M29,22 L24,22 L24,25 L29,25 L29,22 Z M15,19 L10,19 L10,22 L15,22 L15,19 Z M8,19 L3,19 L3,22 L8,22 L8,19 Z M9.639,9 L4.188,9 C3.532,9 3,9.532 3,10.188 L3,10.188 L3,13.437 C3,14.094 3.532,14.625 4.188,14.625 L4.188,14.625 L9.639,14.625 C10.294,14.625 10.826,14.094 10.826,13.437 L10.826,13.437 L10.826,10.188 C10.826,9.532 10.294,9 9.639,9 L9.639,9 Z",
    id: 79
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsDeactivateCard);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-deactivate-card.f279c27b.svg";
export { ForwardRef as ReactComponent };